/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from "../ApiClient";
import AqaPiecemealSnapshotRequest from '../model/AqaPiecemealSnapshotRequest';
import AqaRecordData from '../model/AqaRecordData';
import AqaRecordReviewRequest from '../model/AqaRecordReviewRequest';
import AqaResponse from '../model/AqaResponse';
import FilePiecemealSnapshotIdBody from '../model/FilePiecemealSnapshotIdBody';

/**
* AQAMachineController service.
* @module api/AQAMachineControllerApi
* @version v0
*/
export default class AQAMachineControllerApi {

    /**
    * Constructs a new AQAMachineControllerApi. 
    * @alias module:api/AQAMachineControllerApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instanc
    e} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }

    /**
     * Callback function to receive the result of the closePiecemeal operation.
     * @callback moduleapi/AQAMachineControllerApi~closePiecemealCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Closes a piecemeal snapshot
     * @param {module:model/AqaPiecemealSnapshotRequest} body 
     * @param {String} piecemealSnapshotId 
     * @param {module:api/AQAMachineControllerApi~closePiecemealCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    closePiecemeal(body, piecemealSnapshotId, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling closePiecemeal");
      }
      // verify the required parameter 'piecemealSnapshotId' is set
      if (piecemealSnapshotId === undefined || piecemealSnapshotId === null) {
        throw new Error("Missing the required parameter 'piecemealSnapshotId' when calling closePiecemeal");
      }

      let pathParams = {
        'piecemealSnapshotId': piecemealSnapshotId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaResponse;

      return this.apiClient.callApi(
        '/api/v1/mi/piecemeal/close/{piecemealSnapshotId}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the openPiecemealFromAqd operation.
     * @callback moduleapi/AQAMachineControllerApi~openPiecemealFromAqdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Starts a piecemeal upload from an aqd
     * @param {String} aqdId 
     * @param {module:api/AQAMachineControllerApi~openPiecemealFromAqdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    openPiecemealFromAqd(aqdId, callback) {
      
      let postBody = null;
      // verify the required parameter 'aqdId' is set
      if (aqdId === undefined || aqdId === null) {
        throw new Error("Missing the required parameter 'aqdId' when calling openPiecemealFromAqd");
      }

      let pathParams = {
        'aqdId': aqdId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaResponse;

      return this.apiClient.callApi(
        '/api/v1/mi/piecemeal/open/aqd/{aqdId}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the openPiecemealInSource operation.
     * @callback moduleapi/AQAMachineControllerApi~openPiecemealInSourceCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Starts a piecemeal upload in a source
     * @param {String} sourceId 
     * @param {module:api/AQAMachineControllerApi~openPiecemealInSourceCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    openPiecemealInSource(sourceId, callback) {
      
      let postBody = null;
      // verify the required parameter 'sourceId' is set
      if (sourceId === undefined || sourceId === null) {
        throw new Error("Missing the required parameter 'sourceId' when calling openPiecemealInSource");
      }

      let pathParams = {
        'sourceId': sourceId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaResponse;

      return this.apiClient.callApi(
        '/api/v1/mi/piecemeal/open/source/{sourceId}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the reviewRecord operation.
     * @callback moduleapi/AQAMachineControllerApi~reviewRecordCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Review Record
     * @param {module:model/AqaRecordReviewRequest} body 
     * @param {String} snapshotId 
     * @param {Number} position 
     * @param {String} orientation 
     * @param {module:api/AQAMachineControllerApi~reviewRecordCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    reviewRecord(body, snapshotId, position, orientation, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling reviewRecord");
      }
      // verify the required parameter 'snapshotId' is set
      if (snapshotId === undefined || snapshotId === null) {
        throw new Error("Missing the required parameter 'snapshotId' when calling reviewRecord");
      }
      // verify the required parameter 'position' is set
      if (position === undefined || position === null) {
        throw new Error("Missing the required parameter 'position' when calling reviewRecord");
      }
      // verify the required parameter 'orientation' is set
      if (orientation === undefined || orientation === null) {
        throw new Error("Missing the required parameter 'orientation' when calling reviewRecord");
      }

      let pathParams = {
        'snapshotId': snapshotId,'position': position,'orientation': orientation
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaResponse;

      return this.apiClient.callApi(
        '/api/v1/mi/review/{snapshotId}/{position}/{orientation}', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the uploadRecordData operation.
     * @callback moduleapi/AQAMachineControllerApi~uploadRecordDataCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Uploads a record into a snapshot - in the form of a CSV string
     * @param {module:model/AqaRecordData} body 
     * @param {String} piecemealSnapshotId 
     * @param {module:api/AQAMachineControllerApi~uploadRecordDataCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    uploadRecordData(body, piecemealSnapshotId, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling uploadRecordData");
      }
      // verify the required parameter 'piecemealSnapshotId' is set
      if (piecemealSnapshotId === undefined || piecemealSnapshotId === null) {
        throw new Error("Missing the required parameter 'piecemealSnapshotId' when calling uploadRecordData");
      }

      let pathParams = {
        'piecemealSnapshotId': piecemealSnapshotId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaResponse;

      return this.apiClient.callApi(
        '/api/v1/mi/piecemeal/records/data/{piecemealSnapshotId}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the uploadRecordFile operation.
     * @callback moduleapi/AQAMachineControllerApi~uploadRecordFileCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Uploads a record into an open snapshot
     * @param {String} piecemealSnapshotId 
     * @param {Object} opts Optional parameters
     * @param {module:model/FilePiecemealSnapshotIdBody} opts.body 
     * @param {module:api/AQAMachineControllerApi~uploadRecordFileCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    uploadRecordFile(piecemealSnapshotId, opts, callback) {
      opts = opts || {};
      let postBody = opts['body'];
      // verify the required parameter 'piecemealSnapshotId' is set
      if (piecemealSnapshotId === undefined || piecemealSnapshotId === null) {
        throw new Error("Missing the required parameter 'piecemealSnapshotId' when calling uploadRecordFile");
      }

      let pathParams = {
        'piecemealSnapshotId': piecemealSnapshotId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaResponse;

      return this.apiClient.callApi(
        '/api/v1/mi/piecemeal/records/file/{piecemealSnapshotId}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

}